// 公共方法
let _utils = {
  /**
   * tree转成list
   * @param tree
   * @param parentKey
   * @returns {Array}
   */
  treeToList: (tree, parentKey = null) => {
    let list = [];
    tree.forEach(node => {
      // 将当前节点信息添加到一维数组中
      list.push({
        key: node.key,
        parentKey: parentKey,
        title: node.title
      });
      // 如果当前节点有子节点，则递归调用 convertToArray 处理子节点
      if (node.children && node.children.length > 0) {
        const childrenArray = _utils.treeToList(node.children, node.key);
        list.push(...childrenArray);
      }
    })
    return list;
  },
  /**
   * 获取key的父亲节点的key值
   * @param key
   * @param tree
   * @returns {string}
   */
  getParentKey: (key, tree) => {
    let parentKey = '';
    tree.forEach(node => {
      if (node.children) {
        if (node.children.some(item => item.key === key)) {
          parentKey = node.key;
        } else if (_utils.getParentKey(key, node.children)) {
          parentKey = _utils.getParentKey(key, node.children);
        }
      }
    })
    return parentKey;
  },
  /**
   * 导出Excel文件
   * @param result
   * @param fileName
   */
  exportExcel: (result, fileName) => {
    // IE浏览器以本地方式保存文件（window.navigator.msSaveBlob + window.navigator.msSaveOrOpenBlob）
    //   window.navigator.msSaveBlob：仅为用户提供‘保存’按钮
    //   window.navigator.msSaveOrOpenBlob：不但提供‘保存’按钮，还提供‘打开’按钮
    let blob = new Blob([result]);
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
      let elink = document.createElement('a');
      elink.style.display = 'none';
      elink.href = window.URL.createObjectURL(blob);// 创建URL对象
      elink.download = fileName;// 文件名
      document.body.appendChild(elink);
      elink.click();
      window.URL.revokeObjectURL(elink.href);// 释放URL对象
      document.body.removeChild(elink);// 移除a链接
    }
  },
  /**
   * 16进制颜色值转为RGB
   * @param color
   * @returns {*}
   */
  colorToRGB: color => {
    // 16进制颜色值的正则
    let reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
    // 把颜色值变成小写
    let lowerColor = color.toLowerCase();
    if (reg.test(lowerColor)) {
      // 如果只有三位的值，需变成六位，如：#fff => #ffffff
      if (lowerColor.length === 4) {
        var colorNew = '#';
        for (var i = 1; i < 4; i += 1) {
          colorNew += lowerColor.slice(i, i + 1).concat(lowerColor.slice(i, i + 1));
        }
        lowerColor = colorNew;
      }
      // 处理六位的颜色值，转为RGB
      let colorChange = [];
      for (var i = 1; i < 7; i += 2) {
        colorChange.push(parseInt('0x' + lowerColor.slice(i, i + 2)));
      }
      return `RGB(${colorChange.join(',')})`;
    } else {
      return color;
    }
  },
  /**
   * 获取范围内的随机整数
   * @param min
   * @param max
   * @returns {number}
   */
  getRandomInt: (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  },
  /**
   * 计算音频时间，转化成时分秒
   * @param value
   * @returns {any | string}
   */
  computeTime: value => {
    var timeStr = '';
    timeStr =
      Math.floor(value / 3600) > 9
        ? Math.floor(value / 3600)
        : '0' + Math.floor(value / 3600);
    timeStr +=
      ':' +
      (Math.floor((value % 3600) / 60) > 9
        ? Math.floor((value % 3600) / 60)
        : '0' + Math.floor((value % 3600) / 60));
    timeStr +=
      ':' +
      (Math.floor(((value % 3600) % 60) / 1) > 9
        ? Math.floor(((value % 3600) % 60) / 1)
        : '0' + Math.floor(((value % 3600) % 60) / 1));
    return timeStr;
  },
  /**
   * 字符权限校验
   * @param value
   * @returns {boolean}
   */
  checkPermi: value => {
    const all_permission = "*:*:*";
    const permissions = JSON.parse(sessionStorage.getItem("permissions"));
  
    if (value && value instanceof Array && value.length > 0) {
      const permissionDatas = value
    
      const hasPermission = permissions.some(permission => {
        return all_permission === permission || permissionDatas.includes(permission)
      })
    
      if (!hasPermission) {
        return false
      }
      return true
    } else {
      return false
    }
  },
  /**
   * 获取token，优先从sessionStorage获取，为空则从localStorage获取
   * @returns {string|null}
   */
  getToken: () => {
    return sessionStorage.getItem('token') || localStorage.getItem('token');
  }
};

export default _utils;



// WEBPACK FOOTER //
// ./src/utils/pub-utils.js